import React, { useState } from "react";
import { useQueryParms } from "../../hooks/useQueryParams";
import { useScrollTop } from "../../hooks/useScrollTop";

const LivePlayerMatch = ()=>{
    const { queryParams } = useQueryParms()
    useScrollTop();
    const urlFromMatch = queryParams.get('urlGame');
    const getSrcFromIfrom = (url)=>{
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false`
    }

    return(
        <div style={{height:'100vh', display:'flex', justifyContent:'center', alignItems:'center', position:'relative'}}>
        <iframe 
        src={getSrcFromIfrom(urlFromMatch)} 
        width={window.innerWidth < 600 ? '100%' : '80%'} 
        height="100%" 
        style={{ border: 'none', overflow: 'hidden' }} 
        scrolling="no" 
        frameBorder="0" 
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        allowFullScreen
        title="Facebook Live Video"
      ></iframe>
        </div>

    )

}

export default LivePlayerMatch